import { render } from "./DashboardDaySuccess.vue?vue&type=template&id=951e5b5c&ts=true"
import script from "./DashboardDaySuccess.vue?vue&type=script&lang=ts"
export * from "./DashboardDaySuccess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__